jQuery(document).foundation();
var $ = jQuery;

$(window).scroll(function () {
   whiteonscroll();
});
$(document).ready(function () {
   whiteonscroll();

   if ( $('.page-top-content').children(".left").length == 0 || $('.page-top-content').children(".right").length == 0) {
      $('.full-width-wysiwyg').addClass('smalltop');
   }

      // Dropdown wird geöffnet
      $('.menu-item-has-children').on('classChanged', function() {
         if ($(this).hasClass('is-active')) {
            $('.top-bar-left').addClass('small');
            $('.top-bar').addClass('white');
            console.log('Dropdown geöffnet');
         } else {
            whiteonscroll();
            console.log('Dropdown geschlossen');
         }
      });
   
      // Custom Event für classChanged einrichten
      (function() {
         const observeClassChange = function(mutations) {
            mutations.forEach(function(mutation) {
               if (mutation.attributeName === 'class') {
                     $(mutation.target).trigger('classChanged');
               }
            });
         };
         const observer = new MutationObserver(observeClassChange);
         $('.menu-item-has-children').each(function() {
            observer.observe(this, { attributes: true });
         });
      })();
   

});
function whiteonscroll(){
   if ($(this).scrollTop() > 50) {
      $('.top-bar-left').addClass('small');
      $('.top-bar').addClass('white');
   } else {
      $('.top-bar-left').removeClass('small');
      $('.top-bar').removeClass('white');
   }
}

function parallax_height() {
   if($(".sample-section")){
   var scroll_top = $(this).scrollTop();
   var header_height = $(".sample-header-section").outerHeight();
   $(".sample-section").css({ "margin-top": header_height });
   $(".sample-header").addClass("fixed");
   $(".sample-header").css({ height: header_height - scroll_top });
   }
}
parallax_height();
$(window).scroll(function () {
   parallax_height();
});
$(window).resize(function () {
   parallax_height();
});